import React, { Children, cloneElement } from "react";
import classNames from "classnames";

import "./styles.styl";

export function Tabs(props) {
  let { className, children, ...rest } = props;

  return (
    <div className={classNames("tabs", className)} {...rest}>
      {activateChild(props)}
    </div>
  );
}

export function TabButtons(props) {
  const { className, children, ...rest } = props;

  return (
    <div className={classNames("tab-buttons", className)} {...rest}>
      {activateChild(props)}
    </div>
  );
}

export function Tab(props) {
  const { className, id, active, ...rest } = props;

  return (
    <div
      className={classNames("tab", { "is-active": active }, className)}
      {...rest}
    />
  );
}

export function TabButton(props) {
  const { className, id, active, ...rest } = props;

  return (
    <div
      className={classNames("tab-button", { "is-active": active }, className)}
      {...rest}
    />
  );
}

function activateChild(props) {
  const { children, active } = props;
  const arr = Children.toArray(children);

  // activate given an id
  if (active) {
    arr.some((child, i) => {
      if (child.props.id === active) {
        arr[i] = cloneElement(arr[i], { active: true });
        return true;
      }
    });
  }

  return arr;
}
